export default "__VITE_ASSET__BhuEYQcL__"